import { ApolloClient, InMemoryCache } from "@apollo/client";
import { API_URLS } from "@constants";

export const apolloClient = new ApolloClient({
  uri: API_URLS.GRAPHQL_API,
  cache: new InMemoryCache(),
});
